/**
 * Quando hover typescript no front, incorporar o FcmFirestore.ts no front
 * Arquivo gerado com base em fcm/lib/src/FcmFirestore.ts
 * Não edite o arquivo FcmFirestore.js diretamente
 *
 * Não implementado um wraper de observer
 * Não implementado Wraper de transação, Para obter um path para as transação, pode ser usado a fcmGetRef: firestore.collection('teste').doc('algo').fcmGetRef()
 * Não implementado subcolections, elas não agregam nenhuma vantagem, somente desvantagens, se em algum momento for pertinente, implementar elas
 *
 */
import { getFirestore, collection, getDocs, getDoc, doc, where, query, setDoc, onSnapshot, connectFirestoreEmulator, Timestamp, GeoPoint, serverTimestamp, limit, limitToLast, orderBy, startAfter, startAt, endAt, arrayUnion, arrayRemove, deleteField, increment, or, and, addDoc, updateDoc, deleteDoc, getCountFromServer, getAggregateFromServer, documentId, average, sum, count } from "firebase/firestore";
import { FcmBatch } from "./FcmBatch";
import { getInstanceFcmFirestoreMockup } from './FcmFirestoreMockup';
import { checkValidDocument } from './utils';
function fcmSleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
const FieldValue = {
    serverTimestamp: serverTimestamp,
    arrayUnion: arrayUnion,
    arrayRemove: arrayRemove,
    delete: deleteField,
    increment: increment,
};
const FieldPath = {
    documentId: documentId
};
const AggregateField = {
    average: average,
    sum: sum,
    count: count,
};
const firestoreAdapter = {
    getDocs: getDocs,
    addDoc: addDoc,
    setDoc: setDoc,
    getDoc: getDoc,
    updateDoc: updateDoc,
    deleteDoc: deleteDoc,
    getCountFromServer: getCountFromServer,
    getAggregateFromServer: getAggregateFromServer,
    onSnapshot: onSnapshot
};
export class FcmFirestore {
    _app;
    _firestore;
    FieldPath = FieldPath;
    Timestamp = Timestamp;
    AggregateField = AggregateField;
    GeoPoint = GeoPoint;
    FieldValue = FieldValue;
    adapter = firestoreAdapter;
    fcmMockup = undefined;
    debug = false;
    fcmMockupStart() {
        if (!this.fcmMockup) {
            this.fcmMockup = getInstanceFcmFirestoreMockup(this);
            // @ts-ignore
            this.adapter = this.fcmMockup;
        }
    }
    constructor(app) {
        if (app) {
            this.fcmInit(app);
        }
    }
    fcmInit(app) {
        if (this._app !== undefined) {
            console.error('Não pode inicializar o firebase mais de uma vez!');
        }
        else {
            this._app = app;
            if (this._app) {
                this._firestore = getFirestore(this._app);
            }
            else {
                this._firestore = getFirestore();
            }
        }
    }
    collection(path) {
        return new CollectionReference(this, undefined, { path });
    }
    fcmNewId() {
        return doc(collection(this._firestore, 'newId')).id;
    }
    useEmulator(host, port) {
        connectFirestoreEmulator(this._firestore, host, port);
    }
    batch(maxItems = 499) {
        return new FcmBatch(this, maxItems);
    }
}
export class CollectionReference {
    fcmFirestore;
    path;
    hasOr = false;
    _withConverter;
    type = 'collection';
    queryArgs = [];
    queryExtraArgs = [];
    constructor(fcmFirestore, before, changes) {
        this.fcmFirestore = fcmFirestore;
        this.path = changes?.path || before?.path;
        this.queryArgs = changes?.queryArgs || before?.queryArgs || [];
        this.queryExtraArgs = changes?.queryExtraArgs || before?.queryExtraArgs || [];
        this.hasOr = changes?.hasOr || before?.hasOr || false;
        this._withConverter = changes?._withConverter || before?._withConverter || undefined;
    }
    doc(docId) {
        return new DocumentReference(this.fcmFirestore, this.path, docId);
    }
    async get() {
        if (process.env.NODE_ENV !== 'production') {
            let ret = await this.fcmFirestore.adapter.getDocs(this.fcmGetRef());
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: list', this.toJson(), ret.docs.length);
            }
            return ret;
        }
        else {
            return this.fcmFirestore.adapter.getDocs(this.fcmGetRef());
        }
    }
    fcmGetRef() {
        let ref = null;
        if (this.queryArgs.length || this.queryExtraArgs.length) {
            if (this.hasOr) {
                ref = query(collection(this.fcmFirestore._firestore, this.path), and(...this.queryArgs), ...this.queryExtraArgs);
            }
            else {
                ref = query(collection(this.fcmFirestore._firestore, this.path), ...this.queryArgs, ...this.queryExtraArgs);
            }
        }
        else {
            ref = collection(this.fcmFirestore._firestore, this.path);
        }
        if (this._withConverter) {
            ref = ref.withConverter(this._withConverter);
        }
        return ref;
    }
    async fcmGet() {
        return (await this.get()).docs.map((a) => {
            const obj = a.data();
            obj.id = a.id;
            return obj;
        });
    }
    async fcmGetByDocsIds(ids) {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: fcmGetByDocsIds', this.toJson());
            }
        }
        return this.fcmGetByPropIds(documentId(), ids);
    }
    async fcmGetByPropIds(prop, ids, op = 'in') {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: fcmGetByPropIds', this.toJson());
            }
        }
        const result = [];
        for (let i = 0; i < ids.length; i = i + 30) {
            const ids30 = ids.slice(i, i + 30);
            const trs = await this.where(prop, op, ids30)
                .get();
            for (const trObj of trs.docs) {
                result.push({
                    ...trObj.data(),
                    id: trObj.id
                });
            }
        }
        return result;
    }
    where(field, op, value) {
        if (process.env.NODE_ENV !== 'production') {
            if (!field || value === undefined) {
                console.error('Where com dados inválidos', { field, value }, this.toJson());
            }
        }
        return new CollectionReference(this.fcmFirestore, this, { queryArgs: [...this.queryArgs, where(field, op, value)] });
    }
    limit(size) {
        return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, limit(size)] });
    }
    limitToLast(size) {
        return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, limitToLast(size)] });
    }
    startAfter(item) {
        return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, startAfter(item)] });
    }
    startAt(item) {
        return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, startAt(item)] });
    }
    endAt(item) {
        return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, endAt(item)] });
    }
    orderBy(orderByPath, orderByDirection) {
        if (orderByDirection) {
            return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, orderBy(orderByPath, orderByDirection)] });
        }
        else {
            return new CollectionReference(this.fcmFirestore, this, { queryExtraArgs: [...this.queryExtraArgs, orderBy(orderByPath)] });
        }
    }
    or(args) {
        return new CollectionReference(this.fcmFirestore, this, {
            hasOr: true,
            queryArgs: [...this.queryArgs,
                or(...args.map((a) => where(a[0], a[1], a[2])))]
        });
    }
    add(value) {
        value = value.toFirestore?.() || value;
        if (process.env.NODE_ENV !== 'production') {
            if (!checkValidDocument(value) || !value) {
                console.error('Tentando gravar dados inválidos', value, this.toJson());
            }
        }
        return this.fcmFirestore.adapter.addDoc(collection(this.fcmFirestore._firestore, this.path), value);
    }
    // @ts-ignore
    onSnapshot(...args) {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: listOnSnapshot', this.toJson());
            }
        }
        // @ts-ignore
        return onSnapshot(this.fcmGetRef(), ...args);
    }
    async fcmCount() {
        return (await this.fcmFirestore.adapter.getCountFromServer(this.fcmGetRef())).data().count || 0;
    }
    async fcmAggregate(aggregate) {
        const result = (await this.fcmFirestore.adapter.getAggregateFromServer(this.fcmGetRef(), aggregate));
        return result.data();
    }
    async fcmAggregateByPropIds(prop, ids, aggregate, op = 'in') {
        const result = {};
        for (let i = 0; i < ids?.length; i = i + 30) {
            const ids30 = ids.slice(i, i + 30);
            const trs = await this.where(prop, op, ids30).fcmAggregate(aggregate);
            for (const prop in trs) {
                result[prop] ||= 0;
                result[prop] += trs[prop];
            }
        }
        return result;
    }
    async *fcmGenerator(cacheSize = 100) {
        const ref = this.fcmGetRef();
        let itemsObj = await this.fcmFirestore.adapter.getDocs(query(ref, limit(cacheSize)));
        while (itemsObj.docs && itemsObj.docs.length > 0) {
            const last = itemsObj.docs[itemsObj.docs.length - 1];
            for (const index in itemsObj.docs) {
                const itemObj = itemsObj.docs[index].data();
                itemObj.id = itemsObj.docs[index].id;
                yield itemObj;
            }
            itemsObj = await this.fcmFirestore.adapter.getDocs(query(ref, limit(cacheSize), startAfter(last)));
        }
    }
    /*
  
    async function* (ref, limit=1000) {
    let itemsObj = await ref.limit(limit).get();
    while(itemsObj.docs && itemsObj.docs.length>0) {
      const last = itemsObj.docs[itemsObj.docs.length-1];
      for(const index in itemsObj.docs) {
        const itemObj = itemsObj.docs[index].data();
        Object.defineProperty(itemObj, 'id', {
          enumerable: false,
          value: itemsObj.docs[index].id
        });
        yield itemObj;
      }
      itemsObj = await ref.limit(limit).startAfter(last).get();
    }
  }
     */
    async fcmSliceUpdate(items, pk = 'id', slice = 100, delay = 0, options = { merge: true }) {
        let batch = this.fcmFirestore.batch(slice);
        let iAtual = 0;
        let iLocal = 0;
        let hasError = false;
        try {
            for (iAtual = 0; iAtual < items.length; iAtual++) {
                await batch.set(this.doc(items[iAtual][pk]), items[iAtual], options);
                if (iLocal >= slice) {
                    iLocal = 0;
                    try {
                        // console.log('Commit parcial', iAtual);
                        await batch.commit();
                        if (delay) {
                            await fcmSleep(delay);
                        }
                        //   console.log('Commit end', iAtual);
                    }
                    catch (error) {
                        hasError = true;
                        console.error('Error, await batch.commit();', error);
                    }
                    batch = this.fcmFirestore.batch(slice);
                }
                else {
                    iLocal++;
                }
            }
            if (iLocal > 0) {
                await batch.commit();
            }
        }
        catch (error) {
            hasError = true;
            console.error('Error, await batch.commit();', error);
        }
        if (hasError) {
            return Promise.reject(new Error('Error, await batch.commit();'));
        }
        return 'ok';
    }
    withConverter(obj) {
        return new CollectionReference(this.fcmFirestore, this, { _withConverter: obj });
    }
    toJson() {
        return {
            collection: this.path,
            queryArgs: this.queryArgs.map((a) => {
                return [
                    a.type || '',
                    a._field?.segments?.join('.') || '',
                    a._op || '',
                    a._value || ''
                ];
            }),
            queryExtraArgs: this.queryExtraArgs.map((a) => {
                return [
                    a.type || undefined,
                    a._field?.segments?.join('.') || undefined,
                    a._op || undefined,
                    a._value || undefined,
                    a._limitType || undefined,
                    a._direction || undefined,
                ].filter(item => item !== undefined);
            }),
        };
    }
}
export class DocumentReference {
    fcmFirestore;
    path;
    docId;
    type = 'document';
    _withConverter;
    constructor(fcmFirestore, path, docId) {
        this.fcmFirestore = fcmFirestore;
        this.path = path;
        if (docId === undefined) {
            this.docId = doc(collection(this.fcmFirestore._firestore, path)).id;
        }
        else {
            this.docId = docId;
        }
    }
    async get() {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: DocumentReference.get', this.toJson());
            }
        }
        return this.fcmFirestore.adapter.getDoc(this.fcmGetRef());
    }
    async fcmGet() {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: DocumentReference.fcmGet', this.toJson());
            }
        }
        const doc = await this.fcmFirestore.adapter.getDoc(this.fcmGetRef());
        if (!doc.exists()) {
            return null;
        }
        const obj = doc.data();
        obj.id = doc.id;
        return obj;
    }
    fcmGetRef() {
        if (!this.docId) {
            console.error('Error FcmFirestore: docId não definido', this.docId, this.path);
        }
        if (this._withConverter) {
            return doc(this.fcmFirestore._firestore, this.path, this.docId).withConverter(this._withConverter);
        }
        return doc(this.fcmFirestore._firestore, this.path, this.docId);
    }
    get id() {
        return this.docId;
    }
    set(value, options) {
        value = value.toFirestore?.() || value;
        if (process.env.NODE_ENV !== 'production') {
            if (!checkValidDocument(value) || !value) {
                console.error('Tentando gravar dados inválidos', this.toJson(), value, options);
            }
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: DocumentReference.set', this.toJson(), value, options);
            }
        }
        if (options) {
            return this.fcmFirestore.adapter.setDoc(this.fcmGetRef(), value, options);
        }
        return this.fcmFirestore.adapter.setDoc(this.fcmGetRef(), value);
    }
    update(value, options) {
        value = value.toFirestore?.() || value;
        if (process.env.NODE_ENV !== 'production') {
            if (!checkValidDocument(value) || !value) {
                console.error('Tentando gravar dados inválidos', this.toJson(), value, options);
            }
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: DocumentReference.set', this.toJson(), value, options);
            }
        }
        if (options) {
            return this.fcmFirestore.adapter.updateDoc(this.fcmGetRef(), value, options);
        }
        return this.fcmFirestore.adapter.updateDoc(this.fcmGetRef(), value);
    }
    delete() {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: DocumentReference.delete', this.toJson());
            }
        }
        return this.fcmFirestore.adapter.deleteDoc(this.fcmGetRef());
    }
    // @ts-ignore
    onSnapshot(...args) {
        if (process.env.NODE_ENV !== 'production') {
            if (this.fcmFirestore.debug) {
                console.log('FcmFirestore Debug: getOnSnapshot', this.toJson());
            }
        }
        // @ts-ignore
        return this.fcmFirestore.adapter.onSnapshot(this.fcmGetRef(), ...args);
    }
    withConverter(obj) {
        this._withConverter = obj;
        return this;
    }
    toJson() {
        return {
            path: this.path,
            docId: this.docId,
        };
    }
}
const firestore = new FcmFirestore();
/**
 * Gambiarra para usar na comom de forma análoga ao admin
 */
const FcmFirebase = {
    firestore: () => (firestore)
};
// @ts-ignore
FcmFirebase.firestore.FieldPath = FieldPath;
// @ts-ignore
FcmFirebase.firestore.Timestamp = Timestamp;
// @ts-ignore
FcmFirebase.firestore.GeoPoint = GeoPoint;
// @ts-ignore
FcmFirebase.firestore.FieldValue = FieldValue;
// @ts-ignore
FcmFirebase.firestore.AggregateField = AggregateField;
export { firestore, FieldPath, Timestamp, GeoPoint, FieldValue, FcmFirebase, AggregateField };
